export type State = {
  message: string;
  type: "assertive" | "polite";
};

export const getInitialState = (): State => ({
  message: "",
  type: "polite"
});
